import React from 'react';

import { useFormContext } from 'react-hook-form';

import {
  ModalInputBox,
  ModalInputGroup,
} from '../../../../../../../shared/components/modals';
import {
  ComboBox,
  OptionWithDescription,
} from '../../../../../../../shared/components/form-components';
import { ScanMetadata } from '../../../../../../interfaces/scanMetadata';
import { SocialSharingScanMetricsFormValues } from '../SocialMediaScanMetricsModal.settings';
import { useScanRangeOptions } from '../../../../../../hooks/useScanRangeOptions/useScanRangeOptions';

type DateRangeSectionProps = {
  scansMetadata: ScanMetadata[];
};

const DateRangeSection = ({ scansMetadata }: DateRangeSectionProps) => {
  const { control, watch } = useFormContext<SocialSharingScanMetricsFormValues>();
  const [startScanId, endScanId] = watch(['startScanId', 'endScanId']);

  const { startScanOptions, endScanOptions } = useScanRangeOptions({
    scansMetadata,
    startScanId,
    endScanId,
  });

  const generalInputProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  return (
    <ModalInputBox
      title="Report Date"
      description="You can customize reports to include comparisons of values across different date ranges."
    >
      <ModalInputGroup>
        <ComboBox
          {...generalInputProps}
          name="startScanId"
          label="Start Scan Date"
          options={startScanOptions}
          renderOptionLabel={(option) => (
            <OptionWithDescription
              label={option.label}
              description={option.description}
            />
          )}
        />
        <ComboBox
          {...generalInputProps}
          name="endScanId"
          label="End Scan Date"
          options={endScanOptions}
          renderOptionLabel={(option) => (
            <OptionWithDescription
              label={option.label}
              description={option.description}
            />
          )}
        />
      </ModalInputGroup>
    </ModalInputBox>
  );
};

export { DateRangeSection };
